/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, formValueSelector, change, blur } from 'redux-form';
import { renderDateTimePicker } from '../FieldHelper';

class DateRangeFieldForm extends Component {
  render() {
    let {
      intl,
      translation,
      from = {},
      to = {},
      form,
      formValues = {},
      disabledFrom,
      disabledTo
    } = this.props;

    if (intl && translation) {
      const labelObj = translation.label;
      const placeholderObj = translation.placeholder;
      if (labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
      if (placeholderObj && placeholderObj.message) {
        placeholder = intl.formatMessage(placeholderObj.message, placeholderObj.params);
      }
    }

    const { fromDate, toDate } = formValues;

    return (
      <div className="ui two fields">
        <Field
          name={from.name}
          label={from.label}
          formId={form}
          disabled={disabledFrom}
          component={renderDateTimePicker}
          maxDate={toDate}
          required={from && from.required || false}
        />

        <Field
          name={to.name}
          label={to.label}
          formId={form}
          disabled={disabledTo}
          minDate={fromDate}
          component={renderDateTimePicker}
          required={to && to.required || false}
        />
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  const { meta: { form }, from, to } = props;
  const formSelector = formValueSelector(form);
  const fromDate = formSelector(state, from.name);
  const toDate = formSelector(state, to.name);

  return {
    form: form,
    formValues: {
      fromDate,
      toDate
    },
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    change,
    blur
  }, dispatch);
}

export const DateRangeField = connect(mapStateToProps, mapDispatchToProps)(DateRangeFieldForm);
